import { Loading } from '@/components/loading';
import { FarmMap } from '@/components/maps';
import { CarbonStockKeyTable, FarmMapTable } from '@/components/tables/farm-map-tables.component';
import { H3 } from '@/components/typography';
import { cn } from '@/lib/utils';
import { useFarmMap } from '@/modules/Farms/Farms.api';
import { FarmData } from '@/modules/Report/Report.schema';
import { toast } from 'react-toastify';

type Props = {
  farmId: string;
  farmData: FarmData;
};
export const FarmDetailsMap = ({ farmId, farmData }: Props) => {
  const { data, status } = useFarmMap(farmId);

  if (status === 'error') {
    console.error('Error fetching GeoJSON:');
    toast.error('Failed to retrieve map data. Please try again.');
    return;
  }

  if (status === 'pending') {
    return <Loading />;
  }

  return (
    <div className={cn('flex-col pb-10')}>
      <H3 className="mb-5">Farm Map</H3>
      <CarbonStockKeyTable />
      <div className={cn('flex flex-grow relative w-full aspect-square max-h-[615px] mb-10')}>
        <FarmMap zoom={13} data={data} isFarmMap={true} />
      </div>
      <FarmMapTable
        data={data}
        customerId={farmData.breadcrumb.client.id}
        projectId={farmData.breadcrumb.project.id}
        farmId={farmData.breadcrumb.farm.id}
      />
    </div>
  );
};
